import { createGlobalStyle } from "styled-components";
import Lyno from "./assets/fonts/LynoWalt.otf";
import Pinup from "./assets/fonts/PINUPArial-Bold.otf";
import Lucid from "./assets/fonts/240403-Lucid-Book.otf";
import Cool from "./assets/fonts/CoolveticaRg.otf";
import Roumald from "./assets/fonts/EKRoumaldTest-Roman.ttf";

const GlobalStyle = createGlobalStyle`



 @font-face {
    font-family: 'Lyno';
    src: url(${Lyno}) format('woff2'),
  }

   @font-face {
    font-family: 'Pinup';
    src: url(${Pinup}) format('woff2'),
  }

     @font-face {
    font-family: 'Lucid';
    src: url(${Lucid}) format('woff2'),
  }

      @font-face {
    font-family: 'Cool';
    src: url(${Cool}) format('woff2'),
  }

        @font-face {
    font-family: 'Roumald';
    src: url(${Roumald}) format('woff2'),
  }

`;

export default GlobalStyle;
